import debounce from "lodash-es/debounce";

export default function() {
  let header = $(".site-header");

  console.log(header);

  window.addEventListener(
    "scroll",
    debounce(function() {
      let topPos = $(document).scrollTop();
      if (topPos > 20) {
        header.addClass("is-scrolling");
      } else {
        header.removeClass("is-scrolling");
      }
    }, 150)
  );
}
